<template>
  <form class="md-layout">
    <md-card class="md-layout-item md-size-100">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100"> 
            <md-field :class="getValidationClass('name')">
              <label for="handbook-name">Handbook Name</label>
              <md-input name="handbook-name" id="handbook-name" v-model="handbook.name"/>
                <span class="md-error" v-if="!$v.handbook.name.required">The name is required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="handbook-logo">Logo</label>
              <md-file name="handbook-logo" id="handbook-logo"  accept="image/*" @md-change="handleUploadEvent('logo', $event)"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="handbook-header-bg-color">Header Color</label>
              <md-input type="color" name="handbook-header-color" id="handbook-header-color" v-model="handbook.header_color_hex" />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="handbook-header-text-color">Header Font Color</label>
              <md-input type="color" name="handbook-header-text-color" id="handbook-header-text-color" v-model="handbook.header_text_color_hex" />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="handbook-bg-color">Background Color</label>
              <md-input type="color" name="handbook-bg-color" id="handbook-bg-color" v-model="handbook.bg_color_hex" />
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label for="handbook-action-color">Action Color</label>
              <md-input type="color" name="handbook-action-color" id="handbook-action-color" v-model="handbook.action_color_hex" />
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="handbook-header-font">Header Font</label>
              <md-select name="handbook-header-font" id="handbook-header-font" class="font-input"  v-model="handbook.header_font">
                <md-option value="Alfa Slab One" class="font-alfa-slab-one">Alpha Slab One</md-option>
                <md-option value="Roboto Slab" class="font-roboto-slab">Roboto Slab</md-option>
                <md-option value="Caveat" class="font-caveat">Caveat</md-option>
                <md-option value="Dancing Script" class="font-dancing-script">Dancing Script</md-option>
                <md-option value="Erica One" class="font-erica-one">Erica One</md-option>
                <md-option value="Lato" class="font-lato">Lato</md-option>
                <md-option value="Monospace" class="font-monospace">Monospace</md-option>
                <md-option value="Notable" class="font-notable">Notable</md-option>
                <md-option value="Nunito" class="font-nunito">Nunito</md-option>
                <md-option value="Open Sans" class="font-open-sans">Open Sans</md-option>
                <md-option value="Open Sans Condensed" class="font-open-sans-condensed">Open Sans Condensed</md-option>
                <md-option value="Pinyon Script" class="font-pinyon-script">Pinyon Script</md-option>
                <md-option value="Raleway" class="font-raleway">Raleway</md-option>
                <md-option value="Sans Serif" class="font-sans-serif">Sans Serif</md-option>
                <md-option value="Serif" class="font-serif">Serif</md-option>
                <md-option value="Shadows Into Light" class="font-shadows-into-light">Shadows Into Light</md-option>
                <md-option value="Tangerine" class="font-tangerine">Tangerine</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="handbook-body-font">Body Font</label>
              <md-select name="handbook-body-font" id="handbook-body-font" class="font-input"  v-model="handbook.body_font">
                <md-option value="Alfa Slab One" class="font-alfa-slab-one">Alpha Slab One</md-option>
                <md-option value="Roboto Slab" class="font-roboto-slab">Roboto Slab</md-option>
                <md-option value="Caveat" class="font-caveat">Caveat</md-option>
                <md-option value="Dancing Script" class="font-dancing-script">Dancing Script</md-option>
                <md-option value="Erica One" class="font-erica-one">Erica One</md-option>
                <md-option value="Lato" class="font-lato">Lato</md-option>
                <md-option value="Monospace" class="font-monospace">Monospace</md-option>
                <md-option value="Notable" class="font-notable">Notable</md-option>
                <md-option value="Nunito" class="font-nunito">Nunito</md-option>
                <md-option value="Open Sans" class="font-open-sans">Open Sans</md-option>
                <md-option value="Open Sans Condensed" class="font-open-sans-condensed">Open Sans Condensed</md-option>
                <md-option value="Pinyon Script" class="font-pinyon-script">Pinyon Script</md-option>
                <md-option value="Raleway" class="font-raleway">Raleway</md-option>
                <md-option value="Sans Serif" class="font-sans-serif">Sans Serif</md-option>
                <md-option value="Serif" class="font-serif">Serif</md-option>
                <md-option value="Shadows Into Light" class="font-shadows-into-light">Shadows Into Light</md-option>
                <md-option value="Tangerine" class="font-tangerine">Tangerine</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="handbook-ios-icon">iOS Icon</label>
              <md-file name="handbook-ios-icon" id="handbook-ios-icon" v-model="handbook.ios_icon" accept="image/png" @md-change="handleUploadEvent('ios_icon', $event)"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label for="handbook-ios-launch">iOS Launch Image</label>
              <md-file name="handbook-ios-launch" id="handbook-ios-launch" v-model="handbook.ios_launch_img" accept="image/*" @md-change="handleUploadEvent('ios_launch_img', $event)"/>
            </md-field>
          </div>
        </div>
      </md-card-content>
      <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button class="md-primary" :disabled="sending" v-on:click="handleSaveEvent()">Save</md-button>
          <md-button class="md-accent" :disabled="sending">Cancel</md-button>
        </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
export default {
  name: "HandbookOverview",
  mixins: [validationMixin],
  data (){
    return {
      sending: false
    };
  },
  validations: {
    handbook: {
      name: {
        required
      },
    }
  },
  computed: {
    ...mapState({
      handbook: s => s.handbook.handbook
    })
  },
  methods: {
    ...mapActions([
      'getHandbook',
      'saveHandbook',
      'uploadImage'
    ]),
    getValidationClass (fieldName) {
      const field = this.$v.handbook[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    handleSaveEvent() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.saveHandbook({ handbook: this.handbook })
      }
    },
    handleCancelEvent() {
      this.getHandbook()
    },
    handleUploadEvent (property, event){
      this.uploadImage({property, 'img': event[0]})
    }
  },
  beforeMount () {
    this.getHandbook()
  }
}
</script>
<style>
.font-arial span.md-list-item-text{
  font-family: Arial;
}
.font-sans-serif span.md-list-item-text{
  font-family: "Sans Serif";
}
.font-serif span.md-list-item-text{
  font-family: "Serif";
}
.font-monospace span.md-list-item-text{
  font-family: "Monospace";
}
.font-shadows-into-light span.md-list-item-text{
  font-family: "Shadows Into Light";
}
.font-caveat span.md-list-item-text{
  font-family: "Caveat";
}
.font-dancing-script span.md-list-item-text{
  font-family: "Dancing Script";
}
.font-pinyon-script span.md-list-item-text{
  font-family: "Pinyon Script";
}
.font-tangerine span.md-list-item-text{ 
  font-family: "Tangerine";
}
.font-notable span.md-list-item-text{
  font-family: "Notable";
}
.font-alfa-slab-one span.md-list-item-text{
  font-family: "Alfa Slab One";
}
.font-roboto-slab-one span.md-list-item-text{
  font-family: "Roboto Slab";
}
.font-erica-one span.md-list-item-text{
  font-family: "Erica One";
}
.font-lato span.md-list-item-text{
  font-family: "Lato";
}
.font-raleway span.md-list-item-text{
  font-family: "Raleway";
}
.font-nunito span.md-list-item-text{
  font-family: "Nunito";
}
.font-open-sans span.md-list-item-text{
  font-family: "Open Sans";
}
.font-open-sans-condensed span.md-list-item-text{
  font-family: "Open Sans Condensed";
}
</style>
